import { type FC, useContext } from 'react';

import { useStorePrice } from '@/common/hooks/apple-price';
import { type BingoPackage } from '@/common/types/bingo';
import { StringMain } from '@/components/Typography/Typography';
import {
  RadioButtonContainer,
  type RadioButtonContainerProps,
} from '@/components/ui/RadioButtonContainer/RadioButtonContainer';

import { BuyBingoBallsContext } from '../context';

import css from './styles.module.scss';

interface OfferItemProps extends RadioButtonContainerProps {
  index: number;
  pkg: BingoPackage;
}

const OfferItem: FC<OfferItemProps> = ({ index, pkg, ...props }) => {
  const storePrice = useStorePrice(pkg.amountUsd);
  const { setActiveOfferIndex } = useContext(BuyBingoBallsContext);

  const selectOffer = (): void => {
    setActiveOfferIndex(index);
  };

  return (
    <RadioButtonContainer {...props} onClick={selectOffer}>
      <div className={css.gridItem}>
        <div className="flex items-center gap-1 pl-2">
          <img src="/img/bingo/bingo-icon.png" alt="" className={css.ball} />
          <StringMain weight="bold">{pkg.ballCount}</StringMain>
        </div>
        <div className="flex-1" />
        <StringMain weight="bold" className="text-right text-nowrap ml-auto">
          {storePrice ?? `$ ${pkg.amountUsd}`}
        </StringMain>
      </div>
    </RadioButtonContainer>
  );
};

export { OfferItem };
